// extracted by mini-css-extract-plugin
export var galleryWrapper = "gallery-module--galleryWrapper--S9bBs";
export var galleryImage = "gallery-module--galleryImage--mY0Os";